import React from "react";
import axios from "axios";
import { Button, Container } from "@material-ui/core";
import TrainCard from "literacy/assets/cards/tutorallassigncard";

class PhonemeTutorAllTest extends React.Component {
  constructor() {
    super();
    this.state = { assignments: [] };
  }

  componentDidMount = async () => {
    const doc = await axios.get("/api/literacy/phoneme/test");
    this.setState({ assignments: doc.data });
  };

  render() {
    const { assignments } = this.state;
    return (
      <div>
        <div className="jumbotron">
          <h2>Check Students' Access Assignment</h2>
          <br />
          <Button
            variant="contained"
            color="default"
            href="/literacy/tutor/phoneme"
          >
            Go back
          </Button>
        </div>
        <Container>
          <div style={{ display: "flex" }}>
            {assignments.map((assign, index) => {
              return (
                <TrainCard
                  title={assign.studentName}
                  description={assign.createAt}
                  handleClick={() =>
                    (window.location =
                      "/literacy/tutor/phoneme/test/" + assign._id)
                  }
                />
              );
            })}
          </div>
        </Container>
      </div>
    );
  }
}

export default PhonemeTutorAllTest;
